// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"37f82c75","316":"cad014c7","504":"0d8d502c"}[chunkId] + ".chunk.js";
};